///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'button[windeGreen]',
    standalone: false
})
export class GreenButtonDirective {
    @HostBinding('class') buttonClass = 'winde-button winde-button-with-text winde-green';
}
